/**
 * HTML 특수 문자를 이스케이프합니다.
 * XSS 공격을 방지하기 위해 텍스트를 HTML에 삽입하기 전에 사용합니다.
 *
 * @param text - 이스케이프할 텍스트
 * @returns 이스케이프된 텍스트
 *
 * @example
 * escapeHtml('<script>alert("xss")</script>');
 * // 결과: '&lt;script&gt;alert(&quot;xss&quot;)&lt;/script&gt;'
 *
 * escapeHtml('2024-01-30');
 * // 결과: '2024-01-30'
 */
export const escapeHtml = (text: string): string => {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

/**
 * 런 이름의 #숫자 패턴을 증가시킵니다.
 * 기존에 #숫자가 있으면 1 증가, 없으면 " #1"을 추가합니다.
 *
 * @param originalName - 원본 런 이름
 * @returns 증가된 런 이름
 *
 * @example
 * incrementRunName('my-run #5');
 * // 결과: 'my-run #6'
 *
 * incrementRunName('my-run');
 * // 결과: 'my-run #1'
 */
export const incrementRunName = (originalName: string): string => {
  const numberPattern = /#(\d+)$/;
  const match = originalName.match(numberPattern);

  if (match) {
    const currentNumber = parseInt(match[1], 10);
    const newNumber = currentNumber + 1;
    return originalName.replace(numberPattern, `#${newNumber}`);
  }

  return `${originalName} #1`;
};

/**
 * PDF 파일명으로 사용할 수 없는 문자를 제거합니다.
 *
 * @param filename - 원본 파일명
 * @returns 안전한 파일명
 *
 * @example
 * sanitizeFilename('my/run:name*');
 * // 결과: 'my-run-name'
 */
export const sanitizeFilename = (filename: string): string => {
  return filename.replace(/[/\\:*?"<>|]/g, '-');
};
